// Centred 1000px column on desktop, full width with a 16px gutter below lg.
// (The old md:w-910 was never generated: 910 is not a spacing token, and a
// 910px column would overflow tablets narrower than that anyway.)
const Xpadding = ({ children, className = "" }) => {
	return (
		<div className={`mx-auto w-full max-w-full px-4 lg:px-0 lg:w-1000 ${className}`.trim()}>
			{children}
		</div>
	);
};

export default Xpadding;
